export default {
	formattedLocation() {
		return {
			hash: window.location.hash,
			host: window.location.host,
			hostname: window.location.hostname,
			href: window.location.href,
			origin: window.location.origin,
			pathname: window.location.pathname,
			port: window.location.port,
			protocol: window.location.protocol,
			search: window.location.search,
		};
	},
	formattedWindowSize() {
		return {
			windowWidth: window.innerWidth,
			windowHeight: window.innerHeight,
			width: document.body.clientWidth,
			height: document.body.clientHeight,
		}
	}
}
